<script>
  export let item
  export let base
</script>

<div class="row h-100 no-gutters pad">

  <div class="col-sm-12 my-auto text-center p-5">
    <h1>
      {#if item.title}{item.title}{:else}Sitefiction{/if}
    </h1>
    <div class="w-50 m-auto">
      <p>
        {#if item.tagline}{item.tagline}{:else}Lorem ipsum dolor site amet.{/if}
      </p>
    </div>
  </div>
</div>
